import { InternalTransferMethodEnum, Position } from '@interfaces';
import { CurrentInputAccount, ISelectedAccount } from '@interfaces/models';
import { cashPlusTickers } from '@interfaces/models/money-market-tickers-type';
import { isFixedIncome, isOption, optionsContractMultiplier } from '@shared/helpers';
import { CostBasisPosition } from '@shared/services';
import { toNumber } from '@sharedUtils';

export const hasAccountData = (
  account: CurrentInputAccount | null | undefined,
): account is ISelectedAccount => {
  if (!account || !('accountData' in account)) {
    return false;
  }

  const accountData = (account as ISelectedAccount).accountData;
  return !!accountData && accountData.accountId != null;
};

export const isCashPlusEligiblePosition = (
  position: Pick<Position, 'ticker' | 'settlementFund'>,
  sweepTransferEnabled = false,
): boolean => {
  if (sweepTransferEnabled && position.settlementFund) return true;

  return cashPlusTickers.has(position.ticker);
};

/**
 * Helper function to calculate subtotal for a set of positions
 */
export function calculatePositionsSubtotal(
  positions: CostBasisPosition[] | undefined,
  transferMethod: InternalTransferMethodEnum,
  multiItMoToggleEnabled = false,
): number {
  if (!positions?.length) {
    return 0;
  }

  let value = 0;
  switch (transferMethod) {
    case InternalTransferMethodEnum.PERCENT:
      value = positions.reduce((value, position) => {
        const balance = toNumber(position.balance) * (toNumber(position.percentOfHolding) / 100);
        return value + balance;
      }, 0);
      break;
    case InternalTransferMethodEnum.SHARES:
      value = positions.reduce((value, position) => {
        let price = toNumber(position.price);
        if (isFixedIncome(position.securityType)) {
          price /= 100;
        } else if (multiItMoToggleEnabled && isOption(position.securityType)) {
          price *= optionsContractMultiplier;
        }
        const balance = price * toNumber(position.sharesToTransfer);
        return value + balance;
      }, 0);
      break;
  }

  return Number(value.toFixed(2));
}
